import React, { lazy } from 'react';
import { PlayerEntry } from 'react-player/players';
import { VideoElementProps } from 'react-player/types';
import { AudioConfig } from './AudioPlayer';

declare module 'react-player/types' {
  interface Config {
    audio: AudioConfig;
  }
}

export const AUDIO_EXTENSIONS = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;

export const ReactAudioPlayer: PlayerEntry = {
  key: 'audio',
  name: 'Audio',
  canPlay: (src: string) => AUDIO_EXTENSIONS.test(src),
  player: lazy(() => import('./AudioPlayer')) as unknown as React.LazyExoticComponent<
    React.ComponentType<VideoElementProps>
  >,
};
